const config_PT = require('./pt');
const config_ES = require('./es');
const config_NL = require('./nl');
const config_DE = require('./de');

module.exports = {
    PT: config_PT,
    ES: config_ES,
    NL: config_NL,
    DE: config_DE,
}